import { createSlice } from "@reduxjs/toolkit";
import { createFollowupAppointmentReducer } from "../../reducer/createFollowupAppointment/createFollowupAppointmentReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const createFollowupAppointmentSlice = createSlice({
  name: "createFollowupAppointment",
  initialState,
  reducers: {
    resetCreateFollowupAppointment: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFollowupAppointmentReducer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createFollowupAppointmentReducer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createFollowupAppointmentReducer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetCreateFollowupAppointment } =
  createFollowupAppointmentSlice.actions;

export default createFollowupAppointmentSlice.reducer;
